<template>
  <div class="col-12">
    <b-row>
      <b-col cols="12">
        <Search
          v-if="url"
          :allowCollapse="false"
          :url="url"
          :title="$lang.researchManager"
          :allowFields="$lang.searchResearchManager"
          config="address"
          addModalSize="lg"
          removeModalSize="xl"
          :visibleSearch="false"
          :visibleSettings="false"
          :visibleExport="false"
          :visibleFilters="false"
          :visibleViewCount="true"
          :allowEdit="false"
          :visibleAccordion="true"
          ref="searchResearchManager"
          :dynamicButtons="buttonsAddress"
          :colorTable="true"
          :changeColorTable="changeColorTable"
          :parentPermissions="parentPermissions"
          :remove_item="remove_item"
          :itemTopHeader="itemTopHeader"
          :extraButtons="extraButtons"
          @getPermisson="updatePermissions"
        >
          <template slot="addModal" slot-scope="search">
            <AddResearchManager
              :parentPermissions="permissions"
              @modal-end-up="search.close"
            />
          </template>
        </Search>
        <b-modal
          no-close-on-backdrop
          variant="primary"
          header-bg-variant="primary"
          content-class="border-primary"
          v-model="researchManagerModal"
          size="lg"
          ok-only
          hide-footer
          hide-header
        >
          <ResearchManagerForm
            :title="$lang.researchLang.changeResearchManager"
            :researchManagerLabel="$lang.researchLang.current_research_manager"
            :researcherLabel="$lang.researchLang.new_research_manager"
            :parentLoading="loading"
            :multiple="false"
            :alertInformation="alertInformation"
            :parentPermissions="permissions"
            @closeModal="researchManagerModal = false"
            @submit="changeResearchManager"
          />
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import AddResearchManager from "./addResearchManager";
import { pathOr } from "ramda";
import { isAdmin } from "@/shared/utils";
import ResearchManagerForm from "../forms/researchManagerForm";

export default {
  components: {
    Search,
    AddResearchManager,
    ResearchManagerForm,
  },
  props: {
    parentPermissions: {
      type: Array,
    },
  },
  data() {
    return {
      buttonsAddress: [
        {
          id: "3",
          name: "delete",
        },
        {
          id: "2",
          name: "active",
          activeIcon: "fa fa-unlock-alt fa-lg text-success",
          deActiveIcon: "fa fa-lock fa-lg text-danger",
          hasConfirm: true,
          activeText: "وضعیت فعلی غیر فعال/ با کلیک تغییر به فعال",
          deActiveText: "وضعیت فعلی فعال/ با کلیک تغییر به غیر فعال",
          activeTextConfirm: `با غیر فعال کردن این ارتباط بین مدیر تحقیق و ارزیاب تحقیقات هیچ کدام از این 2 پرونده قابل انتخاب جدید در فرایند تحقیق نمی باشند ولی فرایند‌های جاری قبلی آنها همچنان به قوت خود باقی است.
            <br>زمانی ارتباط را غیر فعال نمائید که ذیگر نمی خواهید از این مدیر تحقیق یا ارزیاب تحقیقات در فرایند تحقیقات جدید استفاده نمائید (اگر از این داده در فرایند تحقیقات استفاده نکرده اید می توانید آنرا حذف نمائید در غیر اینصورت آنرا غیر فعال کنید)
            <br><br><b class="text-danger">آیا از غیر فعال کردن ارتباط اطمینان دارید ؟</b>`,
          deActiveTextConfirm: `با فعال کردن این ارتباط بین مدیر تحقیق و ارزیاب تحقیقات امکان انتخاب مجدد این پرونده‌ها در فرایند تحقیق می باشد.
          <br><br><b class="text-danger">آیا از فعال کردن ارتباط اطمینان دارید ؟</b>`,
        },
      ],
      itemTopHeader: [
        {
          colspan: 6,
          name: this.$lang.research_manager,
        },
        {
          colspan: 5,
          name: this.$lang.researcher,
          variant: "info",
        },
      ],
      url:
        this.$config.api_url +
        this.$config.research.all_research_manager_researcher,
      permissions: [],
      researchManagerModal: false,
      loading: false,
    };
  },
  computed: {
    alertInformation() {
      return `با اعمال تغییر مدیر تحقیق فعلی به مدیر تحقیق جدید کلیه ارزیاب‌های تحقیقات مدیر تحقیق فعلی برای مدیر تحقیق جدید تکثیر می شود و کلیه ارتباط‌های  مدیر تحقیق فعلی با ارزیاب‌هایش غیر فعال می شود سپس کلیه تحقیقاتی که در لیست تحقیق هنوز تمام نشده اند و مدیر تحقیق آنها مدیر تحقیق فعلی است به مدیر تحقیق جدید تغییر می کنند`;
    },
    extraButtons() {
      return [
        {
          name: "changeResearchManager",
          condition: true,
          title: this.$lang.researchLang.changeResearchManager,
          click: this.showResearchManagerModal,
          iconName: "account-switch-outline",
        },
      ];
    },
  },
  methods: {
    pathOr,
    isAdmin,
    updatePermissions(data) {
      this.permissions = [...data];
    },
    getData() {
      this.$refs.searchResearchManager.getItems();
    },
    async changeResearchManager(getPayload) {
      const payload = {
        old_research_manager_parvandeh_code: pathOr(
          null,
          ["research_manager_code"],
          getPayload
        ),
        new_research_manager_parvandeh_code: pathOr(
          null,
          ["researcher_code"],
          getPayload
        ),
      };
      try {
        this.loading = true;
        const url =
          this.$config.api_url + this.$config.research.research_manager;
        const response = await this.$httpService.put(url, payload);
        this.$notify.success(response.data.message);
        this.researchManagerModal = false;
        this.getData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    changeColorTable(allowFields) {
      return Object.keys(allowFields).map((item, i) => {
        return {
          label: allowFields[item],
          key: item,
          sortable: true,
          variant: i > 4 ? "info" : "",
        };
      });
    },
    async remove_item(item) {
      const id = pathOr(null, ["id"], item);
      if (!id) return;
      try {
        const url =
          this.$config.api_url +
          this.$config.research.delete_research_manager_researcher +
          `/${id}`;
        const response = await this.$httpService.delete(url);
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    showResearchManagerModal(){
      this.researchManagerModal = true;
    }
  },
};
</script>

